import api from '../api'
import { CreateEventPayload, EventName, EventResponse } from '@interfaces/events'

export const eventsService = {
  fireEvent: async (payload: CreateEventPayload) => {
    if ([EventName.DOC_VIEWED_BY_RECIPIENT, EventName.RECIPIENT_DOWNLOADED_DOC].includes(payload.name)) {
      return api.post<EventResponse>('/api/events/public', payload).catch(error => {
        console.error('Failed to create event:', error)
      })
    }

    return api.post<EventResponse>('/api/events', payload).catch(error => {
      console.error('Failed to create event:', error)
    })
  },
}
